import { connect } from 'react-redux';
import View from './MobileEditGoalButtonView';
import {
  goalId as selectedGoalIDSelector,
  goalType as selectedGoalTypeSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { RETIREMENT_GOAL_TYPE } from '../../FinancialPlan/Retirement/RetirementConstants';
import {
  EDUCATION_GOAL_TYPE,
  LARGE_PURCHASE_GOAL_TYPE,
  DEBT_MANAGEMENT_GOAL_TYPE,
  EMERGENCY_FUND_GOAL_TYPE,
  HOME_PURCHASE_GOAL_TYPE,
  HEALTHCARE_GOAL_TYPE,
} from '../../FinancialPlan/FinancialPlanConstants';
import { WorkflowEnum } from '../../ClientStartPage/api/useClientStartPageQuery';

const mapStateToProps = (state, ownProps) => ({
  goalId: selectedGoalIDSelector(state, ownProps),
  goalType: selectedGoalTypeSelector(state, ownProps),
});

const mapDispatchToProps = () => ({
  onEditGoal: (clientId, goalType, goalId) => () => {
    switch (goalType) {
      case RETIREMENT_GOAL_TYPE:
        window.ADV.util.Router.go2(WorkflowEnum.Retirement, {
          clientId,
          goToSummaryWhenReady: '1',
        });
        break;
      case DEBT_MANAGEMENT_GOAL_TYPE:
        window.ADV.util.Router.go2(WorkflowEnum.DebtManagement, {
          clientId,
          goToSummaryWhenReady: '1',
        });
        break;
      case EMERGENCY_FUND_GOAL_TYPE:
        window.ADV.util.Router.go2(WorkflowEnum.EmergencyFund, {
          clientId,
          goToSummaryWhenReady: '1',
        });
        break;
      case EDUCATION_GOAL_TYPE:
        window.ADV.util.Router.go2(WorkflowEnum.Education, {
          clientId,
          goToSummaryWhenReady: '1',
          selectedGoalId: goalId,
        });
        break;
      case HOME_PURCHASE_GOAL_TYPE:
        window.ADV.util.Router.go2(WorkflowEnum.HomePurchase, {
          clientId,
          goToSummaryWhenReady: '1',
        });
        break;
      case LARGE_PURCHASE_GOAL_TYPE:
        window.ADV.util.Router.go2(WorkflowEnum.LargePurchase, {
          clientId,
          goToSummaryWhenReady: '1',
          selectedGoalId: goalId,
        });
        break;
      case HEALTHCARE_GOAL_TYPE:
        window.ADV.util.Router.go2(WorkflowEnum.HealthCare, {
          clientId,
          goToSummaryWhenReady: '1',
          selectedGoalId: goalId,
        });
        break;
      default:
        throw Error('Goal type does not have a corresponding workflow');
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
